import { createContext, useContext, useMemo } from 'react';
import { useCookieConsent } from '../hooks/useCookieConsent';
import type { CookieConsentResult } from '../types/cookieConsent';

interface CookieConsentContextValue {
  cookieConsent: CookieConsentResult | null;
  isConsentReady: boolean;
}

const CookieConsentContext = createContext<CookieConsentContextValue>({
  cookieConsent: null,
  isConsentReady: false,
});

interface CookieConsentProviderProps {
  children: React.ReactNode;
  policyUrl?: string;
}

export function CookieConsentProvider({ children, policyUrl }: CookieConsentProviderProps) {
  const { cookieConsent, isLoading } = useCookieConsent(policyUrl);

  const value = useMemo(() => ({ cookieConsent, isConsentReady: !isLoading }), [cookieConsent, isLoading]);

  return <CookieConsentContext.Provider value={value}>{children}</CookieConsentContext.Provider>;
}

export function useCookieConsentContext() {
  return useContext(CookieConsentContext);
}
